import * as fetch from 'isomorphic-fetch';
import { all, put, takeLatest } from 'redux-saga/effects';
import actions from './actions';
import { HFTConfigUrl } from './constants';

export function* rootSaga() {
    yield all([
        takeLatest(actions.types.FETCH_CONFIG.REQUEST, function* saga(action) {
            try {
                const response = yield fetch(HFTConfigUrl);
                const json = yield response.json();
                yield put(actions.creators.fetchConfig.success(json));
            } catch (e) {
                yield put(actions.creators.fetchConfig.failure(action, e));
            }
        }),
    ]);
}



// WEBPACK FOOTER //
// ./src/redux/modules/hft/sagas.tsx